import { Injectable } from '@angular/core';
import { ForceRefethingData } from '@app/core/states/radio.actions';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { merge, Observable, of, Subscription } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RadioWatcherService {
  constructor(private readonly store: Store, private readonly action$: Actions) {}

  dispatchAndWatch(dispached: any): Subscription {
    return merge(
      of(''),
      this.action$.pipe(ofActionDispatched(ForceRefethingData)),
    ).subscribe(() => {
      this.store.dispatch(dispached);
    });
  }

  dispatchAndWatchAsObservable(
    dispached: any,
    otherSource$?: Observable<any>,
  ): Observable<any> {
    if (otherSource$) {
      return merge(
        of(''),
        this.action$.pipe(ofActionDispatched(ForceRefethingData)),
        otherSource$,
      ).pipe(mergeMap(() => this.store.dispatch(dispached)));
    }

    return merge(of(''), this.action$.pipe(ofActionDispatched(ForceRefethingData))).pipe(
      mergeMap(() => this.store.dispatch(dispached)),
    );
  }

  onRefreshDispached(): Observable<any> {
    return this.action$.pipe(ofActionDispatched(ForceRefethingData));
  }
}
